import { render } from "./ConsultBusinessItem.vue?vue&type=template&id=09fa3d15&scoped=true"
import script from "./ConsultBusinessItem.vue?vue&type=script&lang=js"
export * from "./ConsultBusinessItem.vue?vue&type=script&lang=js"

import "./ConsultBusinessItem.vue?vue&type=style&index=0&id=09fa3d15&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fa3d15"]])

export default __exports__